import $ from 'jquery';

$(addHandlers);
$(document).on('vue-loaded', addHandlers);

function addHandlers() {
    $('.youtube-video-button').on('click', function(e) {
        e.preventDefault();
        var youtubeId = $(this).data('video');
        var youtubeEmbed = '<iframe width="1024" height="576" src="https://www.youtube.com/embed/' + youtubeId + '" frameborder="0" allowfullscreen></iframe>';
        $('#youtubehero--container').html(youtubeEmbed);
        NS.openOverlay();
        NS.openModal('modal--youtubehero');
    });

    // close modal callback: Clear YouTube Video
    NS.closedOverlayCallbacks.add(function() {
        $('#youtubehero--container').html("");
    });
}